export default {"src":"/_next/static/media/icon-count-teams.193c1a19.svg","height":512,"width":418};